/**
 * check if access token is set in header
 */
import client from '@/apis/aniftyBackend/client';

const checkAccessToken = (): void => {
  if (!client.defaults.headers.common.Authorization) {
    throw new Error('access token is not set to Authorization header');
  }
};

export default checkAccessToken;
